import { SET_RESULTS } from "./mutation-types";

const mutations = {
  [SET_RESULTS](state, data) {
    state.results = data;
  },
};

export default mutations;
